export default {
    points: [
        { x: 3, y: 0 },
        { x: 4, y: 0 },
        { x: 5, y: 0 },
        { x: 6, y: 0 },
        { x: 7, y: 0 },
        { x: 8, y: 0 },
    ],
    yTicks: [0, 2, 4, 6, 8, 10, 12, 14]
}